export default __webpack_public_path__ + "static/media/Venturer's Armbands of the Second Caste.a89c60ef.jpg";